import { ThemeProvider } from '@emotion/react';
import { GlobalProvider } from './context/GlobalContext';
import { ContactFormProvider } from './context/ContactForm';
import { MenuProvider } from './context/MenuContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './styles/theme';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
// import Project from './pages/Project';
// import Work from './pages/Work';
// import About from './pages/About';

const App = () => {
  return (
    <Router>
      <GlobalProvider>
        <ThemeProvider theme={theme}>
          <ContactFormProvider>
            <MenuProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route path="/work/:slug" element={<Project />} />
                <Route path="/Work" element={<Work />} />
                <Route path="/about" element={<About />} /> */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </MenuProvider>
          </ContactFormProvider>
        </ThemeProvider>
      </GlobalProvider>
    </Router>
  );
};

export default App;
